import state from './moduleComplianceState.js'
import mutations from './moduleComplianceMutations.js'
import actions from './moduleComplianceActions.js'
import getters from './moduleComplianceGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
